import React from "react";
import { View, Heading, Text } from "@aws-amplify/ui-react";

export default function AdminTenantRequired({ title, message }) {
  return (
    <View as="main" maxWidth="1200px" margin="0 auto" padding="2rem">
      <Heading level={3}>{title}</Heading>
      <Text variation="tertiary" marginTop="1rem">
        {message || "Select a tenant in the top bar to continue."}
      </Text>
    </View>
  );
}
